import { Http } from '../../core/http';
import { QuoteApi } from './quote.api';
import { SessionModel } from '../session/model';
import { QuoteCreate, QuoteCreateBody, QuoteModel } from './model';
import { catchError, finalize, first, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { QuoteRepository } from './store';
import { QuoteHelperService } from './quote-helper.service';
import { SessionService } from '../session';

const getQuote = (sessionId: SessionModel['sessionId']) => {
  QuoteRepository.setLoading(true);
  return QuoteHelperService.fetchQuote(sessionId).pipe(
    first(),
    map((res) => {
      QuoteRepository.updateQuote(res);
      return res;
    }),
    catchError((err) => {
      console.log(err);
      return of({} as QuoteModel);
    }),
    finalize(() => QuoteRepository.setLoading(false))
  );
};

const createQuote = (
  sessionId: SessionModel['sessionId'],
  body: QuoteCreateBody
) => {
  return Http.post<QuoteCreate, QuoteCreateBody>(
    QuoteApi.create(sessionId),
    body
  ).pipe(catchError(SessionService.shouldBeSessionError));
};

const resetCacheFetchQuote = () => QuoteHelperService.resetCacheFetchQuote();

export const QuoteService = { getQuote, createQuote, resetCacheFetchQuote };
